import React from 'react'

const NoResultContent = (props) => {
    const { message } = props;
    const isDisplay = props.isDisplay === false ? false : true;
    return (
        <>
            {message !== null && message !== undefined &&
                <div className='alert alert-info' role="alert">
                    <span className='w-100 bs5 d-block'><div className='text-center' dangerouslySetInnerHTML={{ __html: message }} /></span>
                    {isDisplay &&
                        < button type="button" className="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    }
                </div>
            }
        </>
    )
}

export default NoResultContent